import { isUsuarioUsoMuto } from 'utils';
import { FOLHA_PONTO_OLD, PEDIDO_VOO } from 'constants/modules';
import { isRoleAuditoriaNsir } from '../../../../helpers/auditoriaNsirPermission';
import { isAdmin, INSPETOR } from 'constants/role';

/**
 * Itens dinâmicos de Folha de Ponto para o menu lateral (formato legado: href).
 */
export const renderFolhaPonto = (authData, moduleConfigurations) => {
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role)) return [];

  const options = [];
  const showOld = moduleConfigurations?.find(
    u => u.codigo === FOLHA_PONTO_OLD && u.userId === authData.id
  );
  if (showOld) {
    options.push({
      title: 'Folha de Ponto (Antigo)',
      href: '/folha-pontos',
      show: true,
      key: 'inspecao',
    });
  }

  options.push({
    title: 'Folha de Ponto',
    href: '/v2/folha-pontos',
    show: true,
    key: 'inspecao',
  });

  return options;
};

export const renderPedidoVoo = (authData, moduleConfigurations) => {
  const isCustomRole = isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role)
  const rolePermission = isAdmin(authData.role) || authData.role === INSPETOR;

  if (isCustomRole || !rolePermission) return [];

  const options = [];
  const show = moduleConfigurations?.find(
    u => u.codigo === PEDIDO_VOO && (u.userId === authData.id || u.userId === null)
  );
  if (show) {
    options.push({
      title: 'Pedidos de Voo',
      href: '/v2/pedidos-voo',
      show: true,
      key: 'inspecao',
    });
  }

  return options;
};
